import { CwsP, CwsIcon, CwsSpan } from '@components/cws'
import type { FC, PropsWithChildren } from 'react'

interface CartActionProps extends PropsWithChildren {
  variant: 'error' | 'action'
  onClick: () => void
  icon: 'bin' | 'wishlist'
  size: string
}

const colors = {
  error: 'error',
  action: 'buoy-dark',
}

export const CartAction: FC<CartActionProps> = ({ variant, onClick, size = '24px', icon, children }) => {
  return (
    <CwsP color={colors[variant]} onClick={onClick} size="small" className="cursor-pointer cws-m-0 whitespace-nowrap ">
      <div className="flex items-center">
        <div className="flex">
          <CwsIcon className="cws-mr-8 mt-auto mb-auto w-fit" icon={icon} size={size} color={colors[variant]} />
        </div>

        <CwsSpan weight="500" className="whitespace-nowrap mt-auto mb-auto">
          {children}
        </CwsSpan>
      </div>
    </CwsP>
  )
}

export default CartAction
